import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";

import { HuskMigCredentialsService } from "@e-forsyning/common/auth";

export class LoginFormBuilder {
    public static opretForm(huskMigCredentialsService: HuskMigCredentialsService): UntypedFormGroup {
        const { brugernavn, kodeord, huskMig } = huskMigCredentialsService.hent();
        const erEmail = isNaN(Number(brugernavn));

        const builder = new UntypedFormBuilder();
        return builder.group({
            forbrugerNrGroup: builder.group({
                forbrugerNr: [(!erEmail && brugernavn) || null, []],
                kode: [(!erEmail && kodeord) || null, [Validators.required]]
            }),
            emailGroup: builder.group({
                email: [(erEmail && brugernavn) || null, [Validators.email]],
                adgangskode: [(erEmail && kodeord) || null, [Validators.required]]
            }),
            huskMig: [huskMig]
        });
    }
}
